import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { DateService } from 'src/app/services/date/date.service';
import { checklistInterface } from 'src/app/util/interfaces/checklist';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ChecklistHomePageService {
	private checklisthpUrl = environment.baseApiUrl + 'checklisthp';

	private headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService,
		private DateService: DateService
	) {}

	getChecklistTable(searchKey?: string, searchValue?: string): Observable<checklistInterface[]> {
		const parameter = {};
		if (searchKey != undefined && searchValue != undefined && searchKey != '' && searchValue != '') parameter[searchKey] = searchValue;
		return this.http.get<checklistInterface[]>(this.checklisthpUrl, { headers: this.headers, params: parameter }).pipe(
			map((checklistInterfaceArray) => {
				for (const cl of checklistInterfaceArray) {
					const dateFromDescription = cl.description
						.substring(cl.description.indexOf('§_datetime:'), cl.description.lastIndexOf('_§'))
						.replace('§_datetime:', '');

					cl.description = cl.description.replace(/§_datetime:.*_§/, this.DateService.formatDate(dateFromDescription));
				}
				return checklistInterfaceArray;
			})
		);
	}
}
